import _numeral from "numeral";

_numeral.locale("co");

export default function formatNumeric(value) {
  return _numeral(value).format("$ 0,0");
}